module.exports = __webpack_public_path__ + "static/media/crane_yellow.6e15f250.svg";